import { Helmet } from 'react-helmet-async';

interface PageTitleProps {
  title: string;
}

export default function PageTitle({ title }: PageTitleProps) {
  const fullTitle = title ? `${title} — Fox & Quill` : 'Fox & Quill — Where Every Child Is an Author';
  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
}
